<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fRX9yz/tc-custom/9781607054726.jpg?1737671747471" alt="This image is the cover for the book Best Ever Appliqué Sampler from Piece O'Cake Designs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best Ever Appliqué Sampler from Piece O'Cake Designs
      </h1>
      <p class="bookDescription body article font2">
        <b>“Spectacular! . . . Everything you ever wanted to know about how to go about creating appliqué can be found within the pages of this book.” —<i>The Appliqué Society Newsletter</i></b><br/><br/>In this newly updated version of <i>The New Appliqué Sampler </i>from Linda Jenkins and Becky Goldsmith, you’ll find all the latest tips and techniques to help you stitch your own appliqué creations, plus charming new appliqué patterns in the colorful Piece O’ Cake style. Nine new appliqué blocks make charming miniature quilts or mix-and-match samplers. Five new quilt projects include complete instructions and full-size pullout patterns plus basic stitches are shown for both right and left handers.<br/><br/><b>“This is an excellent guide to most types of applique and well worth a place on your reference shelf.” —<i>Fabrications Quilting for You</i></b><br/><br/><b>“I have always been drawn to Piece O’ Cake Designs and this book is no exception. Many of their designs are whimsical and this applique sampler certainly follows their trend. The book includes nine different blocks to mix, match and combine and they are all delightful.” —<i>The Canadian Quilter Magazine</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Becky Goldsmith, Linda Jenkins
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d698ea78